<template>
  <h1>E-commerce templates</h1>
</template>